import React from 'react';
import Select from 'react-select';

const PhoneInputGroup = ({ 
    formik, 
    countryName, 
    phoneName, 
    countries, 
    onCountryChange, 
    placeholder = "Phone number",
    showLabel = true,
    label = "Phone"
}) => {
    
    const countryOptions = (countries || []).map(country => ({
        value: country.id, label: country.name, iso2: country.iso2, phone_code: country.phone_code
    }));

    const formatOptionLabelPhone = ({ label, iso2, phone_code }, { context }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
                src={`https://flagcdn.com/w20/${iso2?.toLowerCase()}.png`}
                style={{ width: 20, height: 15, marginRight: 8, flexShrink: 0 }}
                alt=""
            />
            {context === 'menu' ? (
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <span style={{fontSize: '15px', color: '#000', fontWeight: 'bold', marginRight: '6px'}}>{label}</span>
                    <span style={{fontSize: '15px', color: '#4a5568'}}>{phone_code}</span>
                </div>
            ) : (
                <span style={{fontSize: '14px', color: '#4a5568'}}>{phone_code}</span>
            )}
        </div>
    );

    const hasError = (formik.touched[phoneName] && formik.errors[phoneName]) || (formik.touched[countryName] && formik.errors[countryName]);

    return (
        <div className="custom-input-container mb-3" style={{ textAlign: 'left' }}>
            {showLabel && <label className="custom-input-label">{label}</label>}
            <div 
                className={`d-flex align-items-center ${hasError ? 'border-danger' : 'border'}`} 
                style={{ 
                    borderRadius: '12px', 
                    backgroundColor: '#fff',
                    transition: 'all 0.2s ease-in-out',
                    border: hasError ? '1px solid #dc3545' : '1px solid #e2e8f0'
                }}
            >
                <div style={{ width: '160px', borderRight: '1px solid #e2e8f0', flexShrink: 0 }}>
                    <Select
                        options={countryOptions}
                        value={countryOptions.find(option => option.value === formik.values[countryName]) || null}
                        onChange={(option) => { 
                            formik.setFieldValue(countryName, option?.value || ''); 
                            if (onCountryChange) onCountryChange(option); 
                        }}
                        onBlur={() => formik.setFieldTouched(countryName, true)}
                        formatOptionLabel={formatOptionLabelPhone}
                        placeholder="Select Country"
                        isClearable={false}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        components={{ IndicatorSeparator: () => null }}
                        styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({
                                ...base,
                                border: 0,
                                boxShadow: 'none',
                                backgroundColor: 'transparent',
                                minHeight: '48px',
                                cursor: 'pointer'
                            }),
                            dropdownIndicator: (base) => ({
                                ...base,
                                padding: '0 8px'
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                padding: '0 0 0 12px'
                            }),
                            placeholder: (base) => ({
                                ...base,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontSize: '14px',
                                color: '#a0aec0'
                            })
                        }}
                    />
                </div>
                <input
                    type="text"
                    className="form-control border-0 shadow-none px-3"
                    placeholder={placeholder}
                    name={phoneName}
                    value={formik.values[phoneName]}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{ height: '48px', backgroundColor: 'transparent', width: '100%', outline: 'none' }}
                />
            </div>
            
            <div style={{fontSize: '13px', color: '#718096', marginTop: '6px'}}>
                Use a national or international number valid for the selected country.
            </div>
            
            {formik.touched[phoneName] && formik.errors[phoneName] && (
                <div className="text-danger mt-1" style={{fontSize: '13px'}}>{formik.errors[phoneName]}</div>
            )}
            {formik.touched[countryName] && formik.errors[countryName] && !formik.errors[phoneName] && (
                <div className="text-danger mt-1" style={{fontSize: '13px'}}>{formik.errors[countryName]}</div>
            )}
        </div>
    );
};

export default PhoneInputGroup;
